import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faCloud = cloud('classic', 'thin');
export const falCloud = cloud('classic', 'light');
export const fatCloud = cloud('classic', 'thin');
export const fadCloud = cloud('duotone', 'thin');
export const fasCloud = cloud('classic', 'solid');
export const farCloud = cloud('classic', 'regular');

export default function cloud(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'cloud',
    640, // width
    512, // height
    'f0c2', // unicode
    [
      [
        'classic',
        'solid',
        'M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z',
      ],
      [
        'classic',
        'regular',
        'M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z',
      ],
      [
        'classic',
        'light',
        'M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96l-368 0C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8z',
      ],
      [
        'classic',
        'thin',
        'M523.6 234.2c2.3 4.1 6.2 7.1 10.9 8C585.5 252.6 624 297.8 624 352c0 61.9-50.1 112-112 112l-368 0C73.3 464 16 406.7 16 336c0-55.8 35.7-103.3 85.5-120.8c6.7-2.4 11-8.8 10.7-15.9c-.1-2.4-.2-4.9-.2-7.3c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2c2.2 3.8 5.9 6.6 10.2 7.6s8.8 .2 12.5-2.3c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80c0 10.2-1.9 19.9-5.3 28.8c-1.7 4.4-1.4 9.3 .9 13.4zM386 98.7C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-56.3-36.4-104.1-86.9-121.3c-5-1.7-10.2-3.1-15.5-4.2c1.9-5 3.4-10.1 4.5-15.4c1.3-6.2 1.9-12.6 1.9-19.2c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4z',
      ],
      [
        'duotone',
        'thin',
        [
          'M16 336c0 70.7 57.3 128 128 128l368 0c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336z',
          'M523.6 234.2c2.3 4.1 6.2 7.1 10.9 8C585.5 252.6 624 297.8 624 352c0 61.9-50.1 112-112 112l-368 0C73.3 464 16 406.7 16 336c0-55.8 35.7-103.3 85.5-120.8c6.7-2.4 11-8.8 10.7-15.9c-.1-2.4-.2-4.9-.2-7.3c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2c2.2 3.8 5.9 6.6 10.2 7.6s8.8 .2 12.5-2.3c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80c0 10.2-1.9 19.9-5.3 28.8c-1.7 4.4-1.4 9.3 .9 13.4zM386 98.7C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-56.3-36.4-104.1-86.9-121.3c-5-1.7-10.2-3.1-15.5-4.2c1.9-5 3.4-10.1 4.5-15.4c1.3-6.2 1.9-12.6 1.9-19.2c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4z',
        ],
      ],
    ]
  );
}
